module.exports = {
  publicPath: process.env.NODE_ENV === 'production'
    ? '/dictionary/'
    : (
      process.env.NODE_ENV === 'production-test'
        ? '/dictionary-test/' :
        '/dictionary/'
    ),
  chainWebpack: (config) => {
    config.resolve.symlinks(false)
  }
}
